import { AiVariantContext } from '../types';

export const defaultContext: AiVariantContext = {
  content: null,
  context: null,
  dependency_content: null,
  is_new: true,
};
